import clsx from "clsx";
import type React from "react";

import { createPluggable } from "pluggable-react";
import type { InputProps } from "../../../types/FormTypes";
import styles from "./TextArea.module.scss";
import "../../../styles/focus-ring.scss";

export interface TextAreaProps
  extends Omit<React.ComponentPropsWithoutRef<"textarea">, "onChange" | "value" | "onBlur" | "onFocus">,
    InputProps<string> {
  placeholder?: string;
  rows?: number;
}

const DefaultTextArea = (props: TextAreaProps) => {
  const {
    className,
    value,
    onChange,
    onValueChange,
    placeholder,
    disabled = false,
    error = false,
    fullWidth = false,
    rows = 4,
    ...otherProps
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e as any);
    onValueChange?.(e.target.value);
  };

  return (
    <textarea
      className={clsx(styles.textArea, className)}
      value={value ?? ""}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      rows={rows}
      data-deci-textarea="true"
      data-error={error ? "true" : "false"}
      data-full-width={fullWidth ? "true" : "false"}
      data-focus-ring
      {...otherProps}
    />
  );
};

const TextArea = createPluggable<TextAreaProps>("deci.textarea", DefaultTextArea);

export default TextArea;
